import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton ,IonIcon, IonItem, IonText } from '@ionic/react';
import { useParams } from 'react-router-dom';
import ListItems from '../components/ListItems';
import InnerMenu from '../components/InnerMenu';
import PageEventHandler from "../components/PageEventHandler"
import './Bridges.css';
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { bridgesTranslations } from '../translations/bridges';
import NotificationRedirect from '../components/NotificationRedirect';

const Bridges: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = bridgesTranslations[language];

  const pageBridgesUrl = "https://www.agenziapo.it/content/ponti-e-conche";
  const pageVenetoUrl = "https://infonavigazione.infrastrutturevenete.it/infonavigazione/index.php";

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start">{t.pageTitle}</h1>
        </IonItem>
        <div className="ion-padding ion-text-justify">
          {t.description}
        </div>
        <IonButton 
          target="_blank" 
          rel="noreferrer" 
          href={pageBridgesUrl} 
          expand="block" 
          fill="solid" 
          className="ion-padding bridgeBtn ion-text-wrap"
        >
          {t.checkBridgesButton}
        </IonButton>
        <IonButton 
          target="_blank" 
          rel="noreferrer" 
          href={pageVenetoUrl} 
          expand="block" 
          fill="solid" 
          className="ion-padding bridgeBtn ion-text-wrap"
        >
          {t.checkVenetoButton}
        </IonButton>
      </IonContent>
      <PageEventHandler pageIndex={9} dockIndex={0}/>
      <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Bridges;
